const enum LogLevel {
    WARNING = 'der.warning',
    ERROR = 'der.error',
    LOG = 'der.log',
}

/**
 * Central log dispatcher
 * @param target HTMLElement on which the event will be dispatched
 * @param logLvl LogLevel indicating the severity of the log
 * @param name Name of the log event
 * @param data Additional data to be included with the log event
 */
const dispatch = (target: HTMLElement, logLvl: LogLevel, name: string, data: object): void => {
    const detail: { name: string; data: object } = { name: name.toLocaleLowerCase(), data };

    target.dispatchEvent(
        new CustomEvent(logLvl, {
            detail,
            bubbles: true,
            composed: true,
        })
    );
};

export const dispatchError = (target: HTMLElement, name: string, data: object): void => {
    dispatch(target, LogLevel.ERROR, name, data);
};

export const dispatchWarning = (target: HTMLElement, name: string, data: object): void => {
    dispatch(target, LogLevel.WARNING, name, data);
};

export const dispatchLog = (target: HTMLElement, name: string, data: object): void => {
    dispatch(target, LogLevel.LOG, name, data);
};
